export var HdsIconlibraryData_16px;
(function (HdsIconlibraryData_16px) {
    HdsIconlibraryData_16px["AppSolid_16px"] = "app_solid_16px";
    HdsIconlibraryData_16px["BranchSolid_16px"] = "branch_solid_16px";
    HdsIconlibraryData_16px["CatalogSolid_16px"] = "catalog_solid_16px";
    HdsIconlibraryData_16px["ConflateSolid_16px"] = "conflate_solid_16px";
    HdsIconlibraryData_16px["DatabaseSolid_16px"] = "database_solid_16px";
    HdsIconlibraryData_16px["DeploySolid_16px"] = "deploy_solid_16px";
    HdsIconlibraryData_16px["ExportSolid_16px"] = "export_solid_16px";
    HdsIconlibraryData_16px["IndexSolid_16px"] = "index_solid_16px";
    HdsIconlibraryData_16px["InspectSolid_16px"] = "inspect_solid_16px";
    HdsIconlibraryData_16px["InteractiveSolid_16px"] = "interactive_solid_16px";
    HdsIconlibraryData_16px["LayersSolid_16px"] = "layers_solid_16px";
    HdsIconlibraryData_16px["MarketplaceSolid_16px"] = "marketplace_solid_16px";
    HdsIconlibraryData_16px["MergeAltSolid_16px"] = "merge-alt_solid_16px";
    HdsIconlibraryData_16px["PipelineSolid_16px"] = "pipeline_solid_16px";
    HdsIconlibraryData_16px["RebaseSolid_16px"] = "rebase_solid_16px";
    HdsIconlibraryData_16px["RestSolid_16px"] = "rest_solid_16px";
    HdsIconlibraryData_16px["ReviewSolid_16px"] = "review_solid_16px";
    HdsIconlibraryData_16px["SendToListSolid_16px"] = "send-to-list_solid_16px";
    HdsIconlibraryData_16px["ServicesSolid_16px"] = "services_solid_16px";
    HdsIconlibraryData_16px["StreamSolid_16px"] = "stream_solid_16px";
    HdsIconlibraryData_16px["TemplateSolid_16px"] = "template_solid_16px";
    HdsIconlibraryData_16px["UpdateBaseMapSolid_16px"] = "update-base-map_solid_16px";
    HdsIconlibraryData_16px["VersionedSolid_16px"] = "versioned_solid_16px";
    HdsIconlibraryData_16px["VolatileSolid_16px"] = "volatile_solid_16px";
})(HdsIconlibraryData_16px = HdsIconlibraryData_16px || (HdsIconlibraryData_16px = {}));
export const HDS_ICONLIBRARY_DATA_16PX_CODEPOINTS = {
    [HdsIconlibraryData_16px.AppSolid_16px]: '61697',
    [HdsIconlibraryData_16px.BranchSolid_16px]: '61698',
    [HdsIconlibraryData_16px.CatalogSolid_16px]: '61699',
    [HdsIconlibraryData_16px.ConflateSolid_16px]: '61700',
    [HdsIconlibraryData_16px.DatabaseSolid_16px]: '61701',
    [HdsIconlibraryData_16px.DeploySolid_16px]: '61702',
    [HdsIconlibraryData_16px.ExportSolid_16px]: '61703',
    [HdsIconlibraryData_16px.IndexSolid_16px]: '61704',
    [HdsIconlibraryData_16px.InspectSolid_16px]: '61705',
    [HdsIconlibraryData_16px.InteractiveSolid_16px]: '61706',
    [HdsIconlibraryData_16px.LayersSolid_16px]: '61707',
    [HdsIconlibraryData_16px.MarketplaceSolid_16px]: '61708',
    [HdsIconlibraryData_16px.MergeAltSolid_16px]: '61709',
    [HdsIconlibraryData_16px.PipelineSolid_16px]: '61710',
    [HdsIconlibraryData_16px.RebaseSolid_16px]: '61711',
    [HdsIconlibraryData_16px.RestSolid_16px]: '61712',
    [HdsIconlibraryData_16px.ReviewSolid_16px]: '61713',
    [HdsIconlibraryData_16px.SendToListSolid_16px]: '61714',
    [HdsIconlibraryData_16px.ServicesSolid_16px]: '61715',
    [HdsIconlibraryData_16px.StreamSolid_16px]: '61716',
    [HdsIconlibraryData_16px.TemplateSolid_16px]: '61717',
    [HdsIconlibraryData_16px.UpdateBaseMapSolid_16px]: '61718',
    [HdsIconlibraryData_16px.VersionedSolid_16px]: '61719',
    [HdsIconlibraryData_16px.VolatileSolid_16px]: '61720',
};
//# sourceMappingURL=hds-iconlibrary-data-16px.js.map